<template>
	<div class="partGroup">
		<!--零件组详情弹出框-->
		<el-dialog
			:title="dialogDetails.name?dialogDetails.name:'暂无方案名称'"
			:visible.sync="dialogVisible"
			width="650px"
			:close="handleClose">
			<div class="dialogMain cf">
				<div class="fl" style="width: 48%;">
					<dl>
						<dt>方案名：</dt>
						<dd class="cf">
							{{dialogDetails.name?dialogDetails.name:"暂无方案名称"}}
						</dd>
					</dl>
					<dl>
						<dt>价格：</dt>
						<dd class="cf">
							{{dialogDetails.price?dialogDetails.price:"暂无价格"}}
						</dd>
					</dl>
					<dl>
						<dt>模板id：</dt>
						<dd class="cf">
							{{dialogDetails.templateId}}
						</dd>
					</dl>
					<dl>
						<dt>模板名字：</dt>
						<dd class="cf">
							{{dialogDetails.templateName?dialogDetails.templateName:"暂无模板名字"}}
						</dd>
					</dl>
					<dl>
						<dt>零件缩略图：</dt>
						<dd class="cf">
							<div style="border: 1px solid #ddd; text-align: center; width: 170px;">
								<img :src="dialogDetails.imgUrl" width="100%" alt="暂无图片"/>
							</div>							
						</dd>
					</dl>
				</div>
				<div class="fr" style="width: 48%;padding-right: 10px;">
					<dl>
						<dt>用户名：</dt>
						<dd class="cf">
							{{dialogDetails.realName?dialogDetails.realName:"暂无用户名"}}
						</dd>
					</dl>
					<dl>
						<dt>用户账号：</dt>
						<dd class="cf">
							{{dialogDetails.userAccount?dialogDetails.userAccount:"暂无用户账号"}}
						</dd>
					</dl>
					<dl>
						<dt>资源路径：</dt>
						<dd class="cf">
							<input type="" class="input" placeholder="暂无资源路径" style="border: none;" v-model="dialogDetails.filePath" disabled/>
						</dd>
					</dl>
					<dl>
						<dt>创建时间：</dt>
						<dd class="cf">
							{{dataTimeFn(dialogDetails.createTime)}}
						</dd>
					</dl>
					<dl>
						<dt>修改时间：</dt>
						<dd class="cf">
							{{dataTimeFn(dialogDetails.modifyTime)}}
						</dd>
					</dl>
					<dl>
						<dt>描述：</dt>
						<dd class="cf">
							<div>
								{{dialogDetails.description?dialogDetails.description:"暂无描述"}}
							</div>
						</dd>
					</dl>
				</div>
			</div>
		    <span slot="footer" class="dialog-footer">
		    	<el-button @click="dialogVisible = false">取 消</el-button>
		    </span>
		</el-dialog>
		<!--导航条-->
		<navZcy v-bind:num="'2-3'" style="min-width: 1110px;"></navZcy>
		<div class="line"></div>
		<div class="main">
			<!--页面标题-->
			<div class="top cf">
				<div class="topL fl"><span>整屋方案</span></div>
				<div class="topR fr">
					<el-button type="success" plain @click="refresh"><i class="el-icon-refresh"></i>刷新</el-button>
				</div>
			</div>
			<div class="line"></div>
			<div class="dataTag">
				<!--操作按钮-->
				<div class="handle">
					<div class="handleBtn fl">
						<el-button type="danger" size="small" @click="handleDelete(0,0)">批量删除</el-button>
					</div>
				</div>
				<!--筛选-->
				<div class="filtrateMain">
					<el-row style="text-align: center;">						
						<el-col :span="4">
							<el-input v-model="filtrateData.name" placeholder="方案名" class="inputWidth"></el-input>
						</el-col>						
						<el-col :span="4">
							<el-input v-model="filtrateData.userAccount" placeholder="账号查询" class="inputWidth"></el-input>
						</el-col>						
						<el-col :span="4">
							<el-input v-model="filtrateData.realName" placeholder="真实名查询" class="inputWidth"></el-input>
						</el-col>
						<!--<el-col :span="4">
							<el-select v-model="filtrateData.styleId" placeholder="风格" class="inputWidth">
								<el-option v-for="item in styleOptions" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-col>					-->
						<el-col :span="4">
							<el-input v-model="filtrateData.templateName" placeholder="模板名查询" class="inputWidth"></el-input>
						</el-col>
						<el-col :span="4" style="line-height: 40px;float: right;">
							<el-button type="primary" size="mini" @click="handleSearch()">查询</el-button>
							<el-button type="warning" size="mini" @click="handleReset()">重置</el-button>
						</el-col>
					</el-row>
				</div>
				<!--列表内容-->
				<div class="tableData" style="text-align: center;">
					<el-table 
						ref="multipleTable"
						:data="tableData" 
						border 
						@selection-change="handleSelectionChange" 
						style="width: 100%;border-top: 1px solid #ddd;border-bottom: 1px solid #ddd;">
						<el-table-column type="selection">
						</el-table-column>
						<el-table-column type="index" width="50" label="编号">
					   </el-table-column>
						<el-table-column prop="name" label="方案名" width="130px">
						</el-table-column>
						<el-table-column prop="realName" label="用户名" width="110px">
						</el-table-column>
						<el-table-column prop="userAccount" label="用户账号" width="110px">
						</el-table-column>
						<el-table-column prop="price" label="价格" width="100px">
						</el-table-column>
						<el-table-column prop="imgUrl" label="缩略图" width="75px">
							<template slot-scope="scope">
								<img :src="scope.row.imgUrl" height="20px" alt="缩略图"/>
							</template>
						</el-table-column>						
						<el-table-column prop="templateId" label="模板id" width="70px">
						</el-table-column>					
						<el-table-column prop="templateName" label="模板名字" width="100px">
						</el-table-column>
						<el-table-column prop="createTime" label="创建时间" width="100px">
							<template slot-scope="scope">
								<span>{{dataTimeFn(scope.row.createTime)}}</span>
							</template>
						</el-table-column>
						<el-table-column prop="modifyTime" label="修改时间" width="100px">
							<template slot-scope="scope">
								<span>{{dataTimeFn(scope.row.modifyTime)}}</span>
							</template>
						</el-table-column>
						<!--<el-table-column prop="description" label="描述">
						</el-table-column>-->
						<el-table-column label="操作">
							<template slot-scope="scope">
								<a href="javascript:void(0)" @click="handleDetails(scope.$index, scope.row)" style="color: #1ABC9C;">详情</a>
								<a href="javascript:void(0)" @click="handleDelete(scope.$index, scope.row)" style="color: #1ABC9C;">删除</a>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<!--分页-->
				<div class="page">
					<el-pagination 
						background 
						:current-page="tableDataArr.currentPage" 
						:page-sizes="[10,20,30,40]" 
						:page-size="tableDataArr.pageSize" 
						layout="total, sizes, prev, pager, next, jumper" 
						:total="tableDataArr.totalSize"
				     	@current-change="handleCurrentChange"
				     	@size-change="handleSizeChange">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import '../assets/css/style.css'
import navZcy from './nav'
export default {
	data() {
		return {
			dialogVisible: false,
			dialogDetails: {},
			filtrateData: {
				name: "",			//灯组名
//				styleId: "",		//风格
			},
//			styleOptions: [],
			userOptions: [{
				id: 1,
				name: '用户一'
			}],
			tableDataArr: {			//分页参数
				currentPage: 1,
				pageSize: 10,
				totalSize: 0
			},
			tableData: [],		 	//列表数组参数
			multipleSelection: [],	//列表复选框被选中值
			seriesTag: [], 			//系列表
			sessionId: ''
		}
	},
	methods: {
		//获取风格类型
//		getStyleTag() {
//			let url = "/lightApi/style/inquiryStyle/"+sessionStorage.getItem('sessionId')
//			this.$store.dispatch('handlePost',{'url': url, 'data': {},'Fn': this.getStyleTagFn,'vue':this})
//		},
//		getStyleTagFn(data) {
//			if(data.msg=="ok"){
//				this.styleOptions = data.data.items
//			}else{
//				this.styleOptions = []
//			}
//		},
//		styleIdtoName(id) {
//			for (let i=0; i<this.styleOptions.length; i++) {
//				if(id==this.styleOptions[i].id){
//					return this.styleOptions[i].name
//				}
//			}
//		},
		//获取零件组数据
		queryPrefab() {
			let url = "/lightApi/houseProject/inquiryHouseProject/" + sessionStorage.getItem('sessionId')
			let data = {
				userAccount: this.filtrateData.userAccount,
				realName: this.filtrateData.realName,
				name: this.filtrateData.name,
				templateName: this.filtrateData.templateName,
//				styleId: this.filtrateData.styleId,	  		//用户帐号
				currentPage: this.tableDataArr.currentPage,		
				pageSize: this.tableDataArr.pageSize
			}
			this.$store.dispatch('handlePost',{'url': url, 'data': data,'Fn': this.queryPrefabFn,'vue':this})
		},
		queryPrefabFn(data) {
			if(data.msg=="ok"){
				this.tableDataArr = data.data
				this.tableData = this.tableDataArr.items
			}else{
				this.tableData = []
			}
		},
		//页面刷新
		refresh() {
			location.reload()
		},
		//筛选查询
		handleSearch() {
			this.tableDataArr.currentPage = 1
			this.queryPrefab()
		},
		//重置筛选
		handleReset() {
			this.filtrateData = {}
		},
		//零件详情
		handleDetails(index, row) {
			this.dialogDetails = row			
			this.dialogVisible = true
		},
		//弹出框关闭
		handleClose: function(done) {
			done();
		},
		//列表复选框被选中
		handleSelectionChange: function(val){
			this.multipleSelection=[]
			for (let i=0; i<val.length; i++) {
				this.multipleSelection.push(val[i].id)
			}
		},
		//删除零件组
		handleDelete: function(index, row) {
			let id = []
			if(row!=0){
				id[0] = row.id
			}else{
				id = this.multipleSelection					
			}
			if(id.length>0){
				this.$confirm('此操作将永久删除该零件组, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let url = "/lightApi/houseProject/deleteHouseProject/"+sessionStorage.getItem('sessionId')+"/"+id 
					this.$store.dispatch('handleGet',{'url': url,'Fn': this.handleDeleteFn,'vue':this})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			}else{
				this.$message({
					type: 'info',
					message: '请选择删除项'
				});
			}	
		},
		handleDeleteFn(data) {
			if(data.msg=="ok"){	
				this.queryPrefab()
				this.$message({
					type: 'success',
					message: '删除成功!'
				});
			}else{
				this.$message({
					type: 'error',
					message: data.msg
				});
			}
		},
        //点击页数
		handleCurrentChange(cur) {
			this.tableDataArr.currentPage = cur
			this.queryPrefab()
		},
		//改变显示条目
		handleSizeChange(size) {
			this.tableDataArr.pageSize = size
			this.queryPrefab()
		},
		//时间格式化
		dataTimeFn: function(time){
	   		var oDate
	   		if(time!=""){
				if(typeof(time)=='string'&&time.indexOf(' +0800 CST')!=-1){
					time = time.split(' +0800 CST')[0]
				}
	   			oDate = new Date(time)	
	   		}else{
	   			oDate = new Date()
	   		}
	   					
	  		var mon = oDate.getMonth()+1
	  		var d = oDate.getDate()
	  		if(mon<10){
	  			mon="0"+mon
	  		}
	  		if(d<10){
	  			d="0"+d
	  		}
	  		return oDate.getFullYear()+"-"+mon+"-"+d
	   	}
	},
	created() {
//		this.getStyleTag()
	},
	mounted() {
		this.sessionId = sessionStorage.getItem('sessionId')
		this.queryPrefab()
	},
	components: {
		navZcy
	}
}
</script>

<style scoped>
.dialogMain .fl dl dt {
	width: 94px;
}

.dialogMain .fr dl dt {
	width: 84px;
}
</style>


// WEBPACK FOOTER //
// src/components/houseProject.vue